import React, { useState } from 'react';
import { BadgeCheck, HelpCircle, Plus } from 'lucide-react';
import { SectionHeading } from './SectionHeading';
import { Reveal } from './Reveal';
import { objections } from '../data/objections';
export function ObjectionsSection() {
  const [openId, setOpenId] = useState<string | null>(objections[0].id);
  return <section className="cv-section relative w-full overflow-hidden border-y border-white/[0.06] bg-ink-950 py-14 sm:py-20 md:py-28" data-id="element-130" data-mp="477xknay2cl9">
      <div className="relative mx-auto max-w-3xl px-5 sm:px-6" data-id="element-131" data-mp="3ln7izzmwrfpv">
        <SectionHeading label="Para Escépticos Inteligentes" icon={HelpCircle} title={<>
              Las tres preguntas que <span className="gold-text" data-id="element-133" data-mp="3gpftfc9qk5ou">todos hacen</span>
            </>} data-id="element-132" data-mp="3qhbsoqnk61un" />

        <div className="mt-8 space-y-2.5 sm:mt-12 sm:space-y-3" data-id="element-134" data-mp="32qg7icdly4wd">
          {objections.map((objection, index) => {
          const isOpen = openId === objection.id;
          return <Reveal key={objection.id} delay={index * 0.06} data-id="element-135" data-mp="aqoy6mv136wm" data-mpi={index}>
                <div className={`overflow-hidden rounded-xl border bg-gradient-to-b from-ink-800 to-ink-950 transition-colors ${isOpen ? 'border-gold-400/40' : 'border-white/[0.08] hover:border-white/20'}`} data-id="element-136" data-mp="ap4571od3w0v">
                  <h3 data-id="element-137" data-mp="et23591yb0sc">
                    <button type="button" onClick={() => setOpenId(isOpen ? null : objection.id)} aria-expanded={isOpen} aria-controls={`objection-panel-${objection.id}`} className="flex w-full items-center justify-between gap-3 px-4 py-4 text-left focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-gold-400/60 sm:gap-4 sm:px-6 sm:py-5" data-id="element-138" data-mp="eqfv78b5ej9l">
                      <span className="text-[14px] font-semibold leading-snug text-[#eae7e1] sm:text-base" data-id="element-139" data-mp="2zirfnff6mahv">
                        {objection.question}
                      </span>
                      <span className={`ease-luxe flex h-7 w-7 shrink-0 items-center justify-center rounded-full border border-gold-400/35 bg-gold-400/[0.08] transition-transform duration-300 ${isOpen ? 'rotate-45' : 'rotate-0'}`} aria-hidden="true" data-id="element-140" data-mp="13dilvm9tn39o">
                        <Plus className="h-3.5 w-3.5 text-gold-300" strokeWidth={2} data-id="element-141" data-mp="kibtmshdxoyq" />
                      </span>
                    </button>
                  </h3>

                  <div id={`objection-panel-${objection.id}`} className="ease-luxe grid transition-[grid-template-rows] duration-300" style={{
                gridTemplateRows: isOpen ? '1fr' : '0fr'
              }} data-id="element-142" data-mp="ueowogytlf65">
                    <div className="overflow-hidden" data-id="element-143" data-mp="25wgaful1wbcq">
                      <div className="flex items-start gap-3 border-t border-white/[0.06] px-4 py-4 sm:px-6 sm:py-5" data-id="element-144" data-mp="29udw4nfm4fbd">
                        <BadgeCheck className="mt-0.5 h-4 w-4 shrink-0 text-[#7fbf8f]" strokeWidth={1.8} aria-hidden="true" data-id="element-145" data-mp="3ucy625tz8gjt" />
                        <p className="text-[13.5px] leading-relaxed text-[#a7adb8] sm:text-[14px]" data-id="element-146" data-mp="3gmckg9d51si8">
                          {objection.answer}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </Reveal>;
        })}
        </div>
      </div>
    </section>;
}